import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useController, useFormContext } from 'react-hook-form';
import { FormErrorMessage } from '../error-message';
import { UncontrolledInput } from './uncontrolled';
export const FormInput = ({ name, type, ...props }) => {
    const { register } = useFormContext();
    const { fieldState } = useController({ name });
    const error = fieldState.error?.message;
    return (_jsxs("div", { className: "flex flex-col gap-1 grow", children: [_jsx(UncontrolledInput, { ...props, ...register(name, (type === 'number' ? ({ valueAsNumber: true }) : {})), error: error, type: type }), _jsx(FormErrorMessage, { error: error })] }));
};
export { UncontrolledInput } from './uncontrolled';
